<template>
  <div class="music-info">
    <audio
      ref="musicPlayer"
      @ended="handleMusicEnded"
      @timeupdate="handleTimeUpdate"
    >
      audio not support here
    </audio>

    <div class="music-list">
      <div
        :class="[
          'music-item',
          { 'music-item-active': item.material_url === currentMusicUrl }
        ]"
        :key="item.id"
        v-for="(item, index) in musicList"
      >
        <div class="music-name-wrapper">
          <div
            :class="[
              'music-name',
              {
                'music-name-paying': auditionMusicPlaying(item)
              }
            ]"
            :title="item.material"
          >
            <img
              src="/preview/icon/top_icon.png"
              alt="Top"
              v-if="item.topping"
              class="top-icon"
            />
            {{ item.material }}
          </div>
          <div class="music-duration">{{ formatTime(item.duration || 0) }}</div>
        </div>
        <span
          :class="[
            'icon iconfont music-button',
            'icon-bofang',
            {
              'icon-stop music-button--playing': auditionMusicPlaying(item)
            }
          ]"
          @click.capture.stop="togglePlay(item, index)"
        >
          <!-- {{ auditionMusicPlaying(item) ? "停止" : "试听" }} -->
        </span>
        <a-button-group size="small" class="music-select-button">
          <a-button
            v-if="editing === 'background'"
            class="music-select-button__use"
            @click="replaceBackgroundAudio(item)"
          >
            选择
          </a-button>
          <a-button
            v-else-if="editing"
            class="music-select-button__use"
            @click="replaceAudio(item)"
          >
            选择
          </a-button>
          <template v-else>
            <a-dropdown :trigger="['click']">
              <a-button
                :type="
                  setupMusic && item.id === myVideoMusic.id
                    ? 'primary'
                    : 'default'
                "
                class="music-select-button__btn"
              >
                +
              </a-button>
              <a-menu slot="overlay" @click="handleMenuClick($event, item)">
                <a-menu-item key="background">设为背景音乐</a-menu-item>
                <a-menu-item key="fragment">添加到片段</a-menu-item>
              </a-menu>
            </a-dropdown>
            <a-dropdown :trigger="['click']" v-if="currentOp === 'myMusic'">
              <a-button icon="ellipsis" />
              <a-menu slot="overlay" @click="handleOptionClick($event, item)">
                <a-menu-item key="top">{{
                  item.topping ? "取消置顶" : "置顶"
                }}</a-menu-item>
                <a-menu-item key="delete">删除</a-menu-item>
              </a-menu>
            </a-dropdown>
            <el-tooltip
              v-else
              :content="item.is_collect ? '取消收藏' : '收藏'"
              :enterable="false"
            >
              <a-button
                class="ant-btn-icon-only music-select-button__like"
                :class="{
                  'music-select-button__like--active': item.is_collect
                }"
                @click="toggleLike(item)"
              >
                <a-icon type="heart" theme="filled" />
              </a-button>
            </el-tooltip>
          </template>
        </a-button-group>
      </div>
    </div>
    <a-spin :spinning="loadingStatus === 'loading'">
      <span v-if="!(musicList && musicList.length)" />
    </a-spin>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
// import MenuHeader from "../base/MenuHeader";
import { encodeURIIfNeeded, getAudioDuration } from '../../utils';
import { message } from 'ant-design-vue';

export default {
  name: "MusicInfo",
  components: {},
  props: ['loadingStatus', 'currentOp', 'editing', 'dataList', 'likeOnly', 'music', 'currentTime'],
  data: function () {
    return {
      // progress: 0,
      likeLookup: {}
    };
  },
  computed: {
    ...mapState([
      "setupMusic",
      "myVideoMusic",
      "currentMusic",
      "musicInfoIsPlaying"
    ]),
    currentMusicUrl() {
      return this.$store.state.currentMusic.material_url;
    },
    musicList() {
      return this.dataList.map(m => ({
        ...m,
        is_collect: m.id in this.likeLookup ? this.likeLookup[m.id] : m.is_collect
      })).filter(m => this.likeOnly ? m.is_collect : true);
    },
    backgroundMusicState() {
      return this.setupMusic ? this.myVideoMusic && this.myVideoMusic.id : null;
    },
    isPlaying: {
      get() {
        return this.$store.state.musicMenuIsPlaying;
      },
      set(value) {
        this.handleMusicMenuIsPlaying(value);
      }
    },
    auditionMusic: {
      get() {
        return this.music;
      },
      set(value) {
        this.$emit('update:music', value);
      }
    }
  },
  methods: {
    ...mapMutations([
      "handleCurrentMusic",
      "handleCurrentSubmenu",
      "handleMyVideoMusic",
      "handleMusicMenuIsPlaying",
      'handleMusicStartEnd'
    ]),
    ...mapActions(['addFragmentAudio', 'replaceFragmentAudio', 'delCollect', 'addCollect']),
    playEvent: function (musicPlayer) {
      this.isPlaying = true;
    },
    async selectAndPlay(currentUploadMusic) {
      this.handleCurrentMusic(currentUploadMusic);
      const duration = await getAudioDuration(currentUploadMusic.material_url);

      setTimeout(() => {
        this.handleMyVideoMusic(currentUploadMusic);
        this.handleMusicStartEnd([0, duration]);
      }, 200);
    },
    replaceBackgroundAudio(audio) {
      this.selectAndPlay(audio);
      this.$store.commit('handleAudioEdit', false);
    },

    togglePlay: function (auditionMusic, auditionIndex) {
      auditionMusic.index = auditionIndex
      // this.handleCurrentMusic(auditionMusic);
      // this.handleEffectSelect(null);
      // this.timmer = setTimeout(this.handleCurrentSubmenu.bind(this, 'MusicInfo'), 100);
      // this.handleCurrentMusic(auditionMusic);
      const url = auditionMusic.material_url;
      const { musicPlayer } = this.$refs;
      musicPlayer.removeEventListener('canplay', this.playEvent.bind(null, musicPlayer));
      if (musicPlayer.src === encodeURIIfNeeded(auditionMusic.material_url)) {
        this.isPlaying = !this.isPlaying;
      } else {
        this.auditionMusic = auditionMusic;
        this.isPlaying = false;
        musicPlayer.src = url;
        musicPlayer.addEventListener('canplay', this.playEvent.bind(null, musicPlayer));
      }
    },
    auditionMusicPlaying(item) {
      return this.auditionMusic.material_url === item.material_url && this.isPlaying;
    },
    handleMusicEnded() {
      this.isPlaying = false;
    },
    async handleMenuClick(e, item) {
      switch (e.key) {
        case 'background':
          this.selectAndPlay(item);
          break;
        case 'fragment': {
          const duration = await getAudioDuration(item.material_url);
          this.addFragmentAudio({
            audioId: item.id,
            name: item.material,
            src: item.material_url,
            loop: false,
            volume: 100,
            duration: duration * 1e3,
            crop: [0, duration],
            musicVolume: 100,
            playbackRate: 1,
            fadeIn: false,
            fadeInDuration: 1e3,
            fadeOut: false,
            fadeOutDuration: 1e3
          });
          break;
        }
        default:
          message.error('Unsupported command.');
      }
    },
    async replaceAudio(item) {
      const duration = await getAudioDuration(item.material_url);
      this.replaceFragmentAudio({
        audioId: item.id,
        name: item.material,
        src: item.material_url,
        loop: false,
        volume: 100,
        duration: duration * 1e3,
        crop: [0, duration]
      });
    },
    pauseMusic(item) {
      if (this.auditionMusicPlaying(item)) {
        this.togglePlay(item);
      }
    },
    handleOptionClick(e, item) {
      switch (e.key) {
        case 'top':
          this.$emit('top', { id: item.id, value: !item.topping });
          break;
        case 'delete':
          this.$emit('delete', item.id);
          break;
      }
    },
    async toggleLike(item) {
      const duration = await getAudioDuration(item.material_url);

      if (!item.is_collect) {

        await this.addCollect({
          type: 'material',
          id: item.id,
          material: item.material,
          material_url: item.material_url,
          material_type: 6,
          duration
        });
        this.$set(this.likeLookup, item.id, true);
      } else {
        await this.delCollect({
          type: 'material',
          id: item.id
        });

        this.$set(this.likeLookup, item.id, false);
      }
    },
    handleTimeUpdate(e) {
      this.$emit('update:currentTime', e.target.currentTime)
    },
    formatTime(t) {
      let seconds = Math.floor(t);
      let minutes = Math.floor(seconds / 60);
      seconds %= 60;

      return [
        minutes,
        ('0' + seconds).slice(-2)
      ].join(':');
    }
  },
  watch: {
    isPlaying(val) {
      const { musicPlayer } = this.$refs;
      if (val) {
        musicPlayer.play();
      } else {
        musicPlayer.pause();
      }
    },
    musicInfoIsPlaying() {
      if (this.musicInfoIsPlaying && this.isPlaying) {
        this.isPlaying = false;
      }
    },
    backgroundMusicState() {
      console.log('watching backgroundMusicState');
      console.log(this.backgroundMusicState);
      this.handleCurrentSubmenu('BackgroundAudioFormat');
    }
  },
  // beforeMount() {
  //   this.fetchMusicList();
  // },
  beforeDestroy() {
    const { musicPlayer } = this.$refs;
    musicPlayer.removeEventListener(
      "canplay",
      this.playEvent.bind(null, musicPlayer)
    );
    this.timmer && clearTimeout(this.timmer);
  },
};
</script>

<style scoped>
.music-info {
  /* background: rgba(247, 248, 249, 1);
  box-shadow: -1px 0 0 0 rgba(220, 220, 222, 1);
  padding: 16px; */
  box-sizing: border-box;
  /* height: 100%; */
  display: flex;
  flex-flow: column;
}

.music-info-switch {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.music-item {
  display: flex;
  align-items: center;
  padding: 11px 6px 11px 8px;
  /* cursor: pointer; */
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.music-item:hover {
  background: #e7ecf6;
}

.music-item-active,
.music-item-active:hover {
  background: rgba(215, 220, 230, 1);
}

.music-item:last-child {
  border-bottom: 0;
}

.music-info-icon-wrap {
  width: 32px;
  height: 32px;
  background: rgba(231, 232, 233, 1);
  line-height: 32px;
  text-align: center;
  flex-shrink: 0;
  position: relative;
}

.music-play {
  font-size: 15px;
}

.music-name-wrapper {
  flex-grow: 1;
  font-size: 12px;
}

.music-name {
  font-weight: 400;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
}

.music-duration {
  opacity: 0.7;
}

.music-add {
  visibility: hidden;
  opacity: 0;
  transition: 0.3s;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  line-height: 1;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.8);
  border-radius: 9px;
  color: #656667;
}

.music-add--shown {
  visibility: visible;
  opacity: 0.25;
}

.music-name-paying,
.music-add-paying {
  color: rgba(0, 127, 255, 1);
}

.music-add-paying {
  opacity: 1;
}

.music-add.icon-checked {
  box-shadow: none;
}

.music-list {
  overflow-y: auto;
}

.music-button {
  margin: 0 10px;
  font-size: 14px;
  cursor: pointer;
  color: #007fff;
  visibility: hidden;
  transition: 0.1s;
  opacity: 0;
}

.music-button:before {
  margin-right: 4px;
}

/* .music-button.icon-stop {
  
} */

.music-item:hover .music-button,
.music-button--playing {
  visibility: visible;
  opacity: 1;
}

.music-select-button {
  display: flex;
}

.music-select-button__use {
  font-size: 12px;
}

.music-select-button__btn {
  padding: 0 4px 4px;
  font-size: 20px;
  line-height: 0.8;
}

.music-select-button__like ::v-deep .anticon {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.2);
  transition: 0.2s;
}

.music-select-button__like:hover ::v-deep .anticon,
.music-select-button__like:focus ::v-deep .anticon {
  transform: scale(1.2);
}

.music-select-button__like--active ::v-deep .anticon {
  color: #e48;
}

.top-icon {
  width: 20px;
  height: auto;
  vertical-align: middle;
  margin-right: 4px;
  margin-bottom: 2px;
}
</style>

<style>
/* .music-list > .ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
  position: fixed;
  top: 320px;
  left: 50%;
} */
</style>
